// Состояния для форм загрузки

const STATES = {
    INITIAL: "initial",
    UPLOADING: "uploading",
    FINISHED: "finished",
    ERROR: "error",
};

const isInitial = function (state) {
    return state === STATES.INITIAL;
};

const isFinished = function (state) {
    return state === STATES.FINISHED;
};

const isError = function (state) {
    return state === STATES.ERROR;
};

export default {
    isFinished: isFinished,
    isInitial: isInitial,
    isError: isError,
    STATES: STATES,
};
